module.exports = __webpack_public_path__ + "img/11.44a2d149.jpg";